import { jsx as _jsx } from "react/jsx-runtime";
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
export const GlobalIcon = ({ global, local, mismatched }) => {
    if (global?.global) {
        if (local?.global) {
            return _jsx(PublicIcon, { color: mismatched.length === 0 ? 'primary' : 'warning', sx: { fontSize: 'inherit' } });
        }
        else {
            return _jsx(PublicIcon, { color: mismatched.length === 0 ? 'disabled' : 'warning', sx: { fontSize: 'inherit' } });
        }
    }
    else {
        if (local?.global) {
            return _jsx(PublicOffIcon, { color: "warning", sx: { fontSize: 'inherit' } });
        }
        else {
            return _jsx(PublicOffIcon, { color: "disabled", sx: { fontSize: 'inherit' } });
        }
    }
};
